const files = require.context("./module", true, /.ts$/);
let apiArray = {};
files.keys().forEach((v) => {
  apiArray = { ...apiArray, ...files(v).default };
  //读取文件
});
export const api = apiArray;

